import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../static/common/mp-code.png';
import _imports_1 from '../static/common/miniapp-code.png';

const _withScopeId = n => (_pushScopeId("data-v-0b9a90bc"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "school-header-box"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "title wow slideInDown"
};
const _hoisted_5 = {
  class: "des wow slideInDown"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "qrcode"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "wow zoomIn",
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("img", {
  class: "wow zoomIn",
  "data-wow-delay": "0.1s",
  src: _imports_1,
  alt: ""
})], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    class: "banner",
    src: $data.image
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString($data.title), 1), _createElementVNode("div", _hoisted_5, _toDisplayString($data.des), 1), _hoisted_6])]);
}